import axios from 'axios';
import queryString from 'query-string';
const parsed = queryString.parse(location.search);

window.onload = () => {
    on_resize()
    let utm_campaign = parsed.src || ""

    window.fpg_report_event = report_event

    if (!utm_campaign && (parsed.gclid || parsed.gad_source)) {
        utm_campaign = "gclid"
    }

    if (utm_campaign) {
        var href = `https://store.steampowered.com/app/3422700/Cribbish?utm_source=website&utm_campaign=${utm_campaign}&utm_medium=web`
        document.getElementById("steam_store_link").href = href
        document.getElementById("steam_store_link2").href = href
        document.getElementById("steam_store_link3").href = href
        report_landing(`landing_${utm_campaign}`)
        setTimeout(() => {
            report_event(`${utm_campaign}_stayed_20`)
        }, 20000)

    } else {
        report_landing("landing")
    }
}

window.onresize = (ev) => {
    on_resize()
}
screen.orientation.addEventListener("change", (event) => {
    on_resize()
});

function on_resize() {
    // document.getElementById("dbg").innerText = `width: ${window.innerWidth}, height: ${window.innerHeight}`
}

function report_landing(landing_name) {
    const HOST_URL = "https://rw3xsm6wf5.execute-api.us-west-2.amazonaws.com/default/cribbish_beta"
    var data = {action:"report_landing", property:"fpg", landing_name:landing_name, query_string:location.search, cohort: new Date().toISOString().slice(0, 10)}

    axios.post(HOST_URL, data).then((response) => {
        console.log("Landing reported successfully:", response.data);
    }
    ).catch((error) => {
        console.error("Error reporting Landing:", error);
    });

}
function report_event(event_name) {
    if (event_name === 'steam_store_link1' || event_name === 'steam_store_link2') {
        function gtag() { window.dataLayer.push(arguments); }

        gtag('event', 'conversion', {
            'send_to': 'AW-17023452349/jHTfCMbxsLsaEL2JtbU_',
            'value': 1.0,
            'currency': 'USD',
            'transaction_id': ''
        });
    }

    const HOST_URL = "https://rw3xsm6wf5.execute-api.us-west-2.amazonaws.com/default/cribbish_beta"
    var data = {action:"report_stat", stat_group:"fpg", stat_name:event_name, incr_val:1, cohort: new Date().toISOString().slice(0, 10)}

    console.log("reporting event", event_name)

    axios.post(HOST_URL, data).then((response) => {
        console.log("Event reported successfully:", response.data);
    }
    ).catch((error) => {
        console.error("Error reporting event:", error);
    });
    return true
}